import { useState, useEffect } from 'react';
import './RiskDisclaimerModal.css';

export default function RiskDisclaimerModal({ onAccept }) {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem('w3k_disclaimer_accepted')
  );

  useEffect(() => {
    if (!visible) return;
    function blockEscape(e) {
      if (e.key === 'Escape') e.preventDefault();
    }
    document.addEventListener('keydown', blockEscape, true);
    return () => document.removeEventListener('keydown', blockEscape, true);
  }, [visible]);

  if (!visible) return null;

  function handleAccept() {
    localStorage.setItem('w3k_disclaimer_accepted', 'true');
    setVisible(false);
    onAccept?.();
  }

  return (
    <div className="rd-overlay">
      <div className="rd-card" role="dialog" aria-modal="true" aria-labelledby="rd-title">
        <div className="rd-icon">⚠️</div>
        <h2 id="rd-title" className="rd-title">Fontos figyelmeztetés</h2>

        <div className="rd-body">
          <p>
            A Kripto Terminál és az itt megjelenő elemzések, indikátorok és
            piaci adatok kizárólag oktatási és tájékoztatási célt szolgálnak.
          </p>
          <p className="rd-emphasis">
            NEM minősülnek befektetési tanácsnak, pénzügyi ajánlásnak vagy
            kereskedési megbízásnak.
          </p>
          <p>
            A kriptovaluta kereskedés magas kockázattal jár — elveszítheted befektetett
            tőkéd egy részét vagy egészét. Csak olyan összeget fektess be, amelynek
            elvesztését megengedheted magadnak.
          </p>
        </div>

        <button className="rd-accept-btn" onClick={handleAccept}>
          Megértettem és elfogadom →
        </button>
        <p className="rd-aszf">
          A platform használatával elfogadod a web3kurzus ÁSZF-t.
        </p>
      </div>
    </div>
  );
}
